<template>
  <v-dialog v-model="open" max-width="760" persistent scrollable class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header d-flex align-center px-8 py-6">
        <div class="text-h5">
          <template v-if="isEdit">
            <span style="color: #2655F1;">编辑</span><span>光伏</span>
          </template>
          <template v-else>
            <span style="color: #2655F1;">新增</span><span>光伏</span>
          </template>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="emit('close')" />
      </div>
      <v-card-text class="pa-8 pt-0">
        <div class="form-grid-2">
          <div class="form-group">
            <label>产品型号 <span class="required-star">*</span></label>
            <v-select v-model="draft.productModel" :items="pvModelOptions" item-title="title" item-value="value"
              :loading="pvModelLoading" placeholder="请选择产品型号" variant="flat" density="compact" class="gm-input"
              hide-details @update:model-value="(v) => emit('model-change', v)" />
          </div>
          <div class="form-group">
            <label>光伏名称 <span class="required-star">*</span></label>
            <v-text-field v-model="draft.photovoltaicName" placeholder="请输入光伏名称" variant="flat" density="compact"
              class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>厂家名称</label>
            <v-text-field v-model="draft.factoryName" placeholder="请选择产品型号后自动带出" variant="flat" density="compact"
              class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>UUID <span class="required-star">*</span></label>
            <v-text-field v-model="draft.uuid" placeholder="选择产品型号后自动生成UUID，可编辑" variant="flat" density="compact"
              class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>设备devID</label>
            <v-text-field v-model="draft.devId" placeholder="请输入设备devID" variant="flat" density="compact"
              class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>关联设备devID <span class="required-star">*</span></label>
            <v-select v-model="draft.parentEquipmentId" :items="pileParentEquipmentOptions" item-title="title"
              item-value="value" placeholder="请选择关联设备devID" variant="flat" density="compact" class="gm-input"
              hide-details />
          </div>
          <div class="form-group">
            <label>最大直流电压(V)</label>
            <v-text-field v-model="draft.maxDcVoltage" placeholder="请选择产品型号后自动带出" variant="flat" density="compact"
              class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>最大直流功率(kW)</label>
            <v-text-field v-model="draft.maxDcPower" placeholder="请选择产品型号后自动带出" variant="flat" density="compact"
              class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>额定输出功率(kW)</label>
            <v-text-field v-model="draft.ratedOutputPower" placeholder="请选择产品型号后自动带出" variant="flat"
              density="compact" class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>最大输出功率(kW)</label>
            <v-text-field v-model="draft.maxOutputPower" placeholder="请选择产品型号后自动带出" variant="flat" density="compact"
              class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>最大交流输出电流(A)</label>
            <v-text-field v-model="draft.maxAcOutputCurrent" placeholder="请选择产品型号后自动带出" variant="flat"
              density="compact" class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>最大输入电流(A)</label>
            <v-text-field v-model="draft.maxInputCurrent" placeholder="请选择产品型号后自动带出" variant="flat"
              density="compact" class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>额定电网电压(V)</label>
            <v-text-field v-model="draft.ratedGridVoltage" placeholder="请选择产品型号后自动带出" variant="flat"
              density="compact" class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>额定电网频率(Hz)</label>
            <v-text-field v-model="draft.ratedGridFrequency" placeholder="请选择产品型号后自动带出" variant="flat"
              density="compact" class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>排序号</label>
            <v-text-field v-model.number="draft.sort" type="number" min="0" placeholder="请输入排序号" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="px-8 pb-8 pt-0 justify-end">
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4" @click="emit('close')">取消</v-btn>
        <v-btn color="#2655F1" variant="flat" class="gm-btn-primary px-10 text-white" :loading="submitting"
          @click="emit('submit')">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
const open = defineModel({ type: Boolean, default: false })
defineProps({
  draft: { type: Object, required: true },
  isEdit: { type: Boolean, default: false },
  submitting: { type: Boolean, default: false },
  pvModelOptions: { type: Array, default: () => [] },
  pvModelLoading: { type: Boolean, default: false },
  pileParentEquipmentOptions: { type: Array, default: () => [] },
})
const emit = defineEmits(['close', 'submit', 'model-change'])
</script>

<style scoped lang="scss" src="../styles/step-device.scss"></style>
